let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3Ccf1"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));